import { render } from "./SReCaptcha.vue?vue&type=template&id=db689014"
import script from "./SReCaptcha.vue?vue&type=script&lang=js"
export * from "./SReCaptcha.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__